import React from "react";
import { Link } from "react-router-dom";
import logo from "./assets/logo.png";

const MicrosoftAPIDisclosure = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-slate-900 px-6 py-4">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <Link to="/" className="text-orange-500 text-xl font-bold">
            <img src={logo} alt="Logo" className="h-12 w-auto" />
          </Link>
          <Link
            to="/"
            className="text-white hover:text-orange-500 transition-colors"
          >
            Back to Home
          </Link>
        </div>
      </nav>

      {/* Microsoft API Disclosure Content */}
      <div className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          Microsoft API Services Disclosure
        </h1>
        <p className="text-sm text-gray-600 mb-8">
          Last updated: May 20, 2026
        </p>

        <div className="prose prose-lg text-gray-600 space-y-6">
          <p>
            Jindo integrates with Microsoft services such as Outlook Calendar,
            Outlook Mail, and Microsoft Teams to provide meeting productivity
            and workflow features requested by users.
          </p>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              How We Use Microsoft Data
            </h2>
            <p className="mb-4">
              Jindo may access Microsoft account data to:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>display upcoming meetings</li>
              <li>retrieve meeting participant information</li>
              <li>access meeting join links</li>
              <li>send follow-up emails from the application</li>
              <li>generate summaries and action items related to meetings</li>
            </ul>
            <p className="mt-4">
              Access is limited to the minimum data required to provide these
              features.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Data Usage and Privacy
            </h2>
            <p className="mb-2 font-semibold text-gray-900">
              Jindo does not:
            </p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li>sell Microsoft user data</li>
              <li>use Microsoft user data for advertising</li>
              <li>use Microsoft data for unrelated profiling or analytics</li>
              <li>
                use customer data to train generalized AI or machine learning
                models
              </li>
            </ul>
            <p>
              Microsoft user data is processed solely to provide features
              explicitly requested by the user.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Security
            </h2>
            <p>
              Jindo implements industry-standard security controls including
              encrypted transmission, secure authentication, and restricted
              internal access to customer data.
            </p>
          </section>

          {/* <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              User Control
            </h2>
            <p className="mb-4">
              Users may revoke Jindo's access to their Microsoft account at any
              time through their Microsoft account security and permissions
              settings.
            </p>
            <p>
              <a
                href="https://account.microsoft.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-orange-500 hover:text-orange-600 underline font-medium"
              >
                Microsoft Account Privacy Settings
              </a>
            </p>
          </section> */}

          <section className="mt-12 pt-8 border-t border-gray-300">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Contact</h2>
            <p className="mb-2">
              If you have questions regarding this disclosure or our handling of
              Microsoft user data, please contact:
            </p>
            <p className="font-semibold">Jindo Technologies, LLC</p>
            <p>
              <a
                href="mailto:support@jindolabs.com"
                className="text-orange-500 hover:text-orange-600 underline"
              >
                support@jindolabs.com
              </a>
            </p>
          </section>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 px-6 mt-16">
        <div className="max-w-6xl mx-auto text-center">
          <div className="mb-4 space-x-6">
            <Link
              to="/privacy"
              className="text-gray-400 hover:text-white transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms-of-service"
              className="text-gray-400 hover:text-white transition-colors"
            >
              Terms of Service
            </Link>
            <Link
              to="/google-api-disclosure"
              className="text-gray-400 hover:text-white transition-colors"
            >
              Google API Disclosure
            </Link>
            <Link
              to="/microsoft-api-disclosure"
              className="text-gray-400 hover:text-white transition-colors"
            >
              Microsoft API Disclosure
            </Link>
          </div>
          <p className="text-gray-400">© 2026 Jindo Technologies, LLC</p>
        </div>
      </footer>
    </div>
  );
};

export default MicrosoftAPIDisclosure;
